import { gql } from '@apollo/client';

export const WORKBENCH_METRICS_BAR = gql`
  query WorkbenchMetricsBar($warehouseId: Long!, $statDate: String) {
    workbenchMetricsBar(warehouseId: $warehouseId, statDate: $statDate) {
      warehouseId
      statDate
      noUpdateThresholdHours
      calculatedAt
      metrics {
        metricKey
        valueText
        rawValue
        dodChangeText
        dodChange
        severity
        trend {
          label
          value
        }
      }
    }
  }
`;
